<template>
  <div class="checks-fill">
    <div class="header-title">
      {{ __(item.HeaderTitle) }}
    </div>
    <div class="middle">
      <div class="amount">
        <span class="label">{{ __('Total amount') }}:</span>
        <span class="value">{{ item.Amount }}</span>
      </div>
      <div class="numbers-of-payments">
        <span class="label">{{ __('Numbers of payments') }}:</span>
        <!-- <span class="value" v-if="isSomeChecksFilled">{{
          item.NumbersOfPayments
        }}</span> -->
        <!-- v-else -->
        <div class="payment-controls">
          <!-- :class="{ disabled: item.MaxPayments === item.NumbersOfPayments }" -->
          <svg
            @click="incrementPayments"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.66669"
              y="1.66667"
              width="16.6667"
              height="16.6667"
              rx="5"
              stroke="#469609"
              stroke-width="1.5"
            />
            <path
              d="M7.5 10H12.5"
              stroke="#469609"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 7.49994L10 12.4999"
              stroke="#469609"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="value">{{ item.NumbersOfPayments }}</span>
          <svg
            :class="{ disabled: item.NumbersOfPayments === 1 }"
            @click="decrementPayments"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.66669"
              y="1.66667"
              width="16.6667"
              height="16.6667"
              rx="5"
              stroke="#469609"
              stroke-width="1.5"
            />
            <path
              d="M7.5 10H12.5"
              stroke="#469609"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div class="first-check">
        <span class="label">{{ __('First check date') }}:</span>
        <!-- Todo - exctract to component for easy reuse // Component Purpose - to
        display a date input as text and icon and when clicked it will show a
        calendar to pick a date -->
        <span class="value calendar-date" :class="{ text: isSomeChecksFilled }">
          <span>{{ localFormatDate(item.checks[0].DepositDate) }}</span>
          <SvgIcon name="calendar" />
          <p-vue-calendar
            v-if="!isSomeChecksFilled"
            :placeholder="__('Date')"
            v-model="firstPaymentDate"
            @update:modelValue="updateFirstPaymentDate"
            class="p-inputtext--alt"
          />
        </span>
      </div>
    </div>
    <div class="checks" v-for="(check, index) in item.checks" :key="index">
      <div class="check-header">
        <span class="check-number">{{ __('Check') }} # {{ index + 1 }}</span>
      </div>
      <div class="rest-data">
        <div class="check-details">
          <span class="label">{{ __('SumTotal') + ':' }}</span>
          <p-vue-input-number
            :class="{ 'clean-input': !isCheckOnEdit(check, index) }"
            v-model="check.Amount"
            @blur="handleCheckEditBlur(check, index)"
            @click="handleCheckEdit(check, index)"
            @keydown.enter="handleCheckEditBlur(check, index)"
            @update:modelValue="updateCheck(check, index)"
            :min="0"
            :max="item.Amount"
          />
        </div>
        <div class="check-details calendar-date">
          <span class="label">{{ __('Date') + ':' }}</span>
          <span class="value date">
            {{ localFormatDate(check.DepositDate) }}
          </span>
          <p-vue-calendar
            :placeholder="__('Date')"
            v-model="check.DepositDate"
            @update:modelValue="updateCheckDate(index, $event)"
            class="p-inputtext--alt"
          />
        </div>
      </div>
      <div class="check-actions">
        <div class="check-images" v-if="check.chex_checkID">
          <img
            v-if="checkImages[check.chex_checkID]"
            :src="checkImages[check.chex_checkID].front"
            @click="viewImage(check, checkImages[check.chex_checkID], 'front')"
            alt="Check Front"
            class="check-image"
          />
          <div
            v-else-if="checkImagesError[check.chex_checkID]"
            class="error-images"
          >
            {{ __('Failed to load check images') }}
          </div>
          <img
            v-if="checkImages[check.chex_checkID]"
            :src="checkImages[check.chex_checkID].rear"
            alt="Check Rear"
            class="check-image"
            @click="viewImage(check, checkImages[check.chex_checkID], 'rear')"
          />
          <div
            v-else-if="checkImagesError[check.chex_checkID]"
            class="error-images"
          >
            {{ __('Failed to load check images') }}
          </div>
        </div>
        <button
          v-else
          class="check-button capture-button rounded-light"
          @click="captureCheck(check, index)"
        >
          <SvgIcon name="cameraOutlinedV2" size="26" />
          {{ __('Scan Check') }}
        </button>
      </div>
    </div>
  </div>
  <CheckDisplayer
    v-if="currCheck"
    :check="currCheck"
    :imgUrls="currImgUrls"
    :imgOrient="currImgOrient"
    @close="closeDisplayer"
    @remove="
      () => {
        $emit('removeCheck', currCheck)
        closeDisplayer()
      }
    "
    @capture="() => $emit('removeCheck', currCheck, true)"
  />
</template>

<script>
import { formatDate } from '@/services/apointUtil'
import { checksService } from '@/services/checks.service'
import SvgIcon from '@/components/base/SvgIcon.vue'
import CheckDisplayer from './CheckDisplayer.vue'

export default {
  name: 'ChecksFill',
  props: ['item'],
  emits: [
    'increment',
    'decrement',
    'updateFirstPaymentDate',
    'saveCheck',
    'removeCheck',
    'updateCheck',
  ],
  data() {
    return {
      firstPaymentDate: null,
      checkImages: {},
      checkImagesLoading: {},
      checkImagesError: {},
      currCheck: null,
      currImgUrls: null,
      currImgOrient: null,
      checksOnEdit: {},
    }
  },
  mounted() {
    this.firstPaymentDate = formatDate(this.item.checks[0].DepositDate)
    this.loadCheckImgs()
  },
  methods: {
    async loadCheckImgs() {
      for (const check of this.item.checks) {
        if (check.chex_checkID) {
          this.checkImagesLoading[check.chex_checkID] = true
          this.checkImagesError[check.chex_checkID] = false
          try {
            const [frontImage, rearImage] = await Promise.all([
              checksService.getCheckImg(check.chex_checkID, 'front'),
              checksService.getCheckImg(check.chex_checkID, 'rear'),
            ])
            this.checkImages[check.chex_checkID] = {
              front: frontImage,
              rear: rearImage,
            }
          } catch (error) {
            this.checkImagesError[check.chex_checkID] = true
          } finally {
            this.checkImagesLoading[check.chex_checkID] = false
          }
        }
      }
    },
    closeDisplayer() {
      this.currCheck = null
      this.currImgUrls = null
      this.currImgOrient = null
    },
    viewImage(check, imgUrls, orient) {
      this.currCheck = check
      this.currImgUrls = imgUrls
      this.currImgOrient = orient
    },

    isCheckOnEdit(check, index) {
      return this.checksOnEdit[index]
    },
    handleCheckEdit(check, index) {
      this.checksOnEdit[index] = true
    },
    handleCheckEditBlur(check, index) {
      this.checksOnEdit[index] = false
    },
    updateFirstPaymentDate() {
      this.$emit('updateFirstPaymentDate', this.firstPaymentDate)
    },

    localFormatDate(date) {
      return formatDate(date)
    },
    updateCheckDate(index, newDate) {
      // Create a copy of the check object to avoid mutating props directly
      const updatedCheck = { ...this.item.checks[index], DepositDate: newDate }

      // Emit an event to update the check in the parent component
      this.$emit('updateCheck', index, updatedCheck)
    },
    updateCheck(check, index) {
      this.$emit('updateCheck', { ...check }, index)
    },
    incrementPayments() {
      // if (this.item.NumbersOfPayments === this.item.MaxPayments) return
      this.$emit('increment', this.item.ID)
    },
    decrementPayments() {
      if (this.item.NumbersOfPayments === 1) return
      if (this.item.NumbersOfPayments > 1) {
        // Prevent negative payments
        this.$emit('decrement', this.item.ID)
      }
    },

    captureCheck(check, index) {
      this.$emit('saveCheck', check, index)
    },
  },
  computed: {
    isSomeChecksFilled() {
      return this.item.checks.some((check) => check.chex_checkID)
    },
    maxDate() {
      const maxDate = new Date()

      maxDate.setDate(maxDate.getDate() + this.item.MaxDaysForwardLimit)
      return maxDate
    },
  },
  components: {
    SvgIcon,
    CheckDisplayer,
  },
}
</script>
